module.exports = __webpack_public_path__ + "img/add.cb99554e.svg";